module.exports = __webpack_public_path__ + "static/guardian_icon-bcbf9b641efc5d95123a601e1488d58b.png";